import { isInaccessible } from "@testing-library/react";
import { createContext, useContext, useEffect, useReducer } from "react";

// Initial state
const initialState = {
    isAdvRule: false,
    supportsAdvRules: false,
    isLock: false,
    isRegularOutput: false,
    isInput: false,
    isPulse: false,
    deviceUUID: "",
    siteType: "",
    selectedRulePin: null,
    selectedPinsToAffect: [],
    supportsOutputPulse: false,
    supportsInputPulse: false,
    pinName: "",
    pinType: "OUTPUT",
    pinNumber: 0,
    pinStatusOn: "",
    pinStatusOff: "",
    inputType: -1,
    inputRule: 0,
    ruleTime: 0,
    ruleSentence: "",
    inputTypeCopy: 0,
    success: false,

    //new rule items
    site_owner: "",
    name: "",
    description: "",
    conditions_logic_operator: "AND",
    enabled: true,
    conditions: [],
    days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
    // condition_type: "STATE_CHECK",
    // pin: 0,
    // pin_state: "ANY",
    // trigger_event: "PULSE",
    // time_condition: "ANYTIME",
    actions: [],
    actionToAdd: {},
    // site_to: "",
    // action_type: "",
    // execution_order: 1,
    // delay_seconds: 0,
    // control_type: "",
    // target_output: ""
};

// Reducer function
const ruleReducer = (state, action) => {

    switch (action.type) {
        case "SET_SUPPORTS_ADV_RULES":
            return { ...state, supportsAdvRules: action.payload };
        case "SET_IS_ADV_RULE":
            return { ...state, isAdvRule: action.payload };
        case "SET_ADV_RULE_ACTION": 
            return { ...state, actions: action.payload };
        case "SET_ADV_RULE_CONDITION": 
            return { ...state, conditions: action.payload };
        case "SET_RULE_NAME": 
            return { ...state, name: action.payload };
        case "SET_RULE_DESCRIPTION": 
            return { ...state, description: action.payload };
        case "SET_IS_PULSE": 
            return { ...state, isPulse: action.payload };
        case "SET_ACTION_TO_ADD": 
            return { ...state, actionToAdd: action.payload };
        case "SET_EXECUTION_DAYS": 
            return { ...state, days_of_week: action.payload }
        case "SET_IS_LOCK":
            return { ...state, isLock: action.payload };
        case "SET_IS_REGULAR_OUTPUT":
            return { ...state, isRegularOutput: action.payload };
        case "SET_IS_INPUT":
            return { ...state, isInput: action.payload };
        case "SET_DEVICE_UUID":
            return { ...state, deviceUUID: action.payload };
        case "SET_SITE_TYPE":
            return { ...state, siteType: action.payload };
        case "SET_SELECTED_PIN":
            return { ...state, selectedRulePin: action.payload };
        case "SET_SELECTED_PINS_TO_AFFECT":
            return { ...state, selectedPinsToAffect: action.payload };
        case "SET_SUPPORTS_OUTPUT_PULSE":
            return { ...state, supportsOutputPulse: action.payload };
        case "SET_SUPPORTS_INPUT_PULSE":
            return { ...state, supportsInputPulse: action.payload };
        case "SET_PIN_NAME":
            return { ...state, pinName: action.payload };
        case "SET_PIN_TYPE":
            return { ...state, pinType: action.payload };
        case "SET_PIN_NUMBER":
            return { ...state, pinNumber: action.payload };
        case "SET_PIN_STATUS_ON":
            return { ...state, pinStatusOn: action.payload };
        case "SET_PIN_STATUS_OFF":
            return { ...state, pinStatusOff: action.payload };
        case "SET_INPUT_TYPE":
            return { ...state, inputType: action.payload };
        case "SET_INPUT_RULE":
            return { ...state, inputRule: action.payload };
        case "SET_RULE_TIME":
            return { ...state, ruleTime: action.payload };
        case "SET_RULE_SENTENCE":
            return {...state, ruleSentence: action.payload};
        case "SET_INPUT_TYPE_COPY":
            return { ...state, inputTypeCopy: action.payload };
        case "RESET":
            return initialState;
        default:
            return state;
    }

    
};

// Create context
const RuleContext = createContext();

// Provider component
export const RuleProvider = ({ children }) => {
    const [state, dispatch] = useReducer(ruleReducer, initialState);

    useEffect(() => {
    }, [state.inputRule]);

    return (
        <RuleContext.Provider value={{ state, dispatch }}>
            {children}
        </RuleContext.Provider>
    );
};

// Custom hook for accessing the context
export const useRule = () => useContext(RuleContext);